import {
  FIND_MAIL_FAILED,
  FIND_MAIL_REQUEST,
  FIND_MAIL_SUCCESS,
  FORGOT_FAILED,
  FORGOT_LOADING,
  FORGOT_SUCCESS,
} from "../constants";

const INITIAL_STATE = {
  findByEmailData: {},
  isLoading: false,
};

const forgotReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case FORGOT_LOADING:
      return {
        ...state,
        isLoading: true,
      };
    case FORGOT_FAILED:
      return INITIAL_STATE;
    case FORGOT_SUCCESS:
      return {
        current: action.payload,
        isLoading: false,
      };
    case FIND_MAIL_REQUEST:
      return {
        ...state,
        isLoading: true,
      };
    case FIND_MAIL_FAILED:
      return INITIAL_STATE;
    case FIND_MAIL_SUCCESS:
      return {
        findByEmailData: action.payload,
        isLoading: false,
      };
    default:
      return state;
  }
};

export default forgotReducer;
